import ReactModal from 'react-modal';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import { modalStyle } from '../../../../../../../utils/modal';
// components
import { Spinner } from '../../../../../../../components/Spinner';
// API
import { useAuth } from '../../../../../../../hooks/useAuth';
import { useEnv } from '../../../../../../../context/env-context';
import { makeRequest } from '../../../../../../../utils/makeRequest';
import { toast } from 'react-toastify';

function RewardDuplicateModal({
  setReward,
  setRewardsList,
  duplicateModal,
  setDuplicateModal,
  rewardsRequest,
}) {
  const { apiOriginConsumer } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [spinner, setSpinner] = useState(false);

  const closeModal = () => setDuplicateModal(null);

  const handleUpdate = async () => {
    setSpinner(true);

    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const { sourceType, newType } = duplicateModal;

    const config = {
      token,
      url: `${apiOriginConsumer}/rewards/type/duplicate`,
      method: 'POST',
      data: JSON.stringify({ sourceType, newType }),
    };

    try {
      await makeRequest(config);
      const reward = await rewardsRequest({ url: 'type', payload: { type: newType } });

      setRewardsList(prev => [...prev, { ...reward, uuid: crypto.randomUUID() }]);
      setReward(reward);
      setDuplicateModal(null);

      toast.success('New reward type created successfully!');
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSpinner(false);
    }
  };

  return (
    <ReactModal
      isOpen={!!duplicateModal}
      style={modalStyle({ width: '460px' })}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onRequestClose={closeModal}
    >
      <Spinner visible={spinner}>
        <h5>Duplicate Reward:</h5>
        <div className="mt-4 d-flex flex-column gap-3">
          <div>
            <Form.Label className="mb-1">ID</Form.Label>
            <Form.Control
              className="bo-input w-100"
              type="text"
              value={duplicateModal?.newType}
              onChange={e => setDuplicateModal(prev => ({ ...prev, newType: e.target.value }))}
            />
          </div>
        </div>
        <Row>
          <Col className="mt-5 d-flex gap-3 justify-content-center">
            <Button
              className="bo-button"
              disabled={!duplicateModal?.newType}
              onClick={handleUpdate}
            >
              Duplicate
            </Button>
            <Button className="bo-button" onClick={closeModal}>
              Cancel
            </Button>
          </Col>
        </Row>
      </Spinner>
    </ReactModal>
  );
}

export default RewardDuplicateModal;
